var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2334.94 977.06",
    style: {
      enableBackground: "new 0 0 2334.94 977.06"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E81D2D;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#263C83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.71,178.45l-72.96,67.31c-14.7-0.66-29.52,0.12-44.22,2.39c-0.16,0.04-0.37,0.04-0.53,0.08 c-48.68,7.62-93.48,31.18-127.3,66.98c-26.01,27.56-44.43,61.09-53.68,97.42c-2.81,10.87-4.75,22-5.86,33.28 c-0.45,4.82-0.78,9.64-0.91,14.46l-72.96,67.39c-2.6-12.56-4.38-25.29-5.33-38.1c-1.28-17.05-1.12-34.23,0.58-51.41 c6.52-66.32,34.89-128.6,80.72-177.08c45.83-48.48,106.49-80.41,172.47-90.75c32.66-5.15,65.69-4.82,97.81,0.7 C521.4,172.97,532.14,175.4,542.71,178.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M634,94.17l-60.37,55.69c-9.7-3.5-19.61-6.55-29.6-9.1c-28.16-7.25-57.35-10.92-86.83-10.71 c-78.33,0.54-154.05,28.22-214.21,78.22c-60.16,50.05-101.03,119.33-115.69,196.11c-7.31,38.43-7.84,77.52-1.82,115.63 c1.94,12.23,4.54,24.34,7.85,36.33l-60.37,55.74c-4.25-11.29-8.01-22.74-11.23-34.31c-16.89-60.63-19.74-124.73-7.8-187.34 c17.88-93.67,67.8-178.32,141.25-239.37c73.45-61.09,165.86-94.87,261.48-95.52c52.03-0.37,103.22,9.1,151.08,27.52h0.04 C616.66,86.43,625.41,90.14,634,94.17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M760.18,489.12c-2.97,41.07-14.37,80.99-33.36,117.31c-4.29,8.2-8.96,16.19-14,24.02l-57.6-57.46 c4.58-8.4,8.59-17.13,11.98-26.03c7.84-20.26,12.63-41.68,14.25-63.52c2.6-36.13-3.72-72.42-18.37-105.54 c-0.5-1.15-0.99-2.31-1.53-3.46c-2.93-6.34-6.19-12.56-9.7-18.58l58.96-54.46c4.58,6.84,8.83,13.88,12.8,21.09 c3.47,6.18,6.65,12.52,9.62,18.95C754.56,387.62,763.85,438.41,760.18,489.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M856.84,616.57c-10.78,27.72-24.53,54.09-40.92,78.72c-5.03,7.58-10.32,14.95-15.85,22.2l-53.43-53.26 c5.37-7.42,10.41-15.07,15.15-22.94c9.91-16.4,18.41-33.74,25.39-51.7c17.01-43.62,24.73-90.37,22.63-137.13 c-2.11-46.79-13.91-92.64-34.73-134.62c-4.79-9.64-9.99-19.03-15.69-28.13c-4.34-7-8.92-13.8-13.79-20.43l55.16-50.91 c5.03,6.59,9.87,13.39,14.49,20.27c9.91,14.75,18.83,30.15,26.76,46.14c25.43,51.28,39.84,107.22,42.4,164.36 C886.98,506.26,877.56,563.27,856.84,616.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 466.84,
    cy: 857.67,
    r: 36.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 466.84,
    cy: 857.67,
    r: 21.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 606.18,
    cy: 895.32,
    r: 36.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 606.18,
    cy: 895.32,
    r: 21.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 911.21,
    cy: 921.69,
    r: 36.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 911.21,
    cy: 921.69,
    r: 21.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M770.3,55.38L770.3,55.38c7.79,8.38,7.31,21.48-1.07,29.27l-554.2,515.15c-8.38,7.79-21.48,7.31-29.27-1.07 h0c-7.79-8.38-7.31-21.48,1.07-29.27l554.2-515.15C749.41,46.53,762.52,47,770.3,55.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M760.32,165L760.32,165c7.79,8.38,7.31,21.48-1.07,29.27L319.76,602.8c-8.38,7.79-21.48,7.31-29.27-1.07h0 c-7.79-8.38-7.31-21.48,1.07-29.27l439.49-408.53C739.43,156.14,752.54,156.62,760.32,165z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600.9,891.67L600.9,891.67c-8.2,7.98-21.31,7.81-29.29-0.39L291.53,603.7c-7.98-8.2-7.81-21.31,0.39-29.29 h0c8.19-7.98,21.31-7.81,29.29,0.39l280.07,287.58C609.26,870.57,609.09,883.69,600.9,891.67z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.78,
    y: 428.17,
    transform: "matrix(0.7164 -0.6977 0.6977 0.7164 -299.1649 697.5912)",
    className: "st1",
    width: 41.42,
    height: 577.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.68,857.15L464.68,857.15c-8.2,7.98-21.31,7.81-29.29-0.39L186.31,600.99 c-7.98-8.2-7.81-21.31,0.39-29.29h0c8.19-7.98,21.31-7.81,29.29,0.39l249.09,255.77C473.05,836.05,472.88,849.17,464.68,857.15z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.44,
    y: 569.56,
    transform: "matrix(0.7164 -0.6977 0.6977 0.7164 -345.6757 665.8113)",
    className: "st1",
    width: 41.42,
    height: 377.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 764.34,
    cy: 55.53,
    r: 36.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 764.34,
    cy: 55.53,
    r: 21.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 762.04,
    cy: 160.66,
    r: 36.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 762.04,
    cy: 160.66,
    r: 21.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -76.2557 955.3762)",
    className: "st1",
    cx: 523.33,
    cy: 522.5,
    rx: 36.67,
    ry: 36.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -76.2557 955.3761)",
    className: "st1",
    cx: 523.33,
    cy: 522.5,
    rx: 21.61,
    ry: 21.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -184.6106 1053.9731)",
    className: "st1",
    cx: 527.09,
    cy: 635.48,
    rx: 36.67,
    ry: 36.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -184.6105 1053.9733)",
    className: "st1",
    cx: 527.09,
    cy: 635.48,
    rx: 21.61,
    ry: 21.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 779.41,
    cy: 895.32,
    r: 36.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 779.41,
    cy: 895.32,
    r: 21.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1107.8,708.87v85.38h-11.15v-85.38H1107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1277.82,794.24h-11.15l-44.83-67.98v67.98h-11.15v-85.5h11.15l44.83,67.86v-67.86h11.15V794.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1392.65,792.1c-4.45-2-7.94-4.78-10.47-8.33c-2.53-3.55-3.84-7.66-3.92-12.31h11.88 c0.41,4,2.06,7.37,4.96,10.11c2.9,2.74,7.12,4.1,12.68,4.1c5.31,0,9.49-1.33,12.55-3.98c3.06-2.65,4.59-6.06,4.59-10.23 c0-3.26-0.9-5.92-2.7-7.96c-1.8-2.04-4.04-3.59-6.74-4.65c-2.7-1.06-6.33-2.21-10.9-3.43c-5.63-1.47-10.15-2.94-13.54-4.41 c-3.39-1.47-6.29-3.78-8.7-6.92c-2.41-3.14-3.61-7.37-3.61-12.68c0-4.65,1.18-8.78,3.55-12.37c2.37-3.59,5.7-6.37,9.98-8.33 c4.29-1.96,9.21-2.94,14.76-2.94c8,0,14.56,2,19.66,6c5.1,4,7.98,9.31,8.63,15.92h-12.25c-0.41-3.26-2.12-6.14-5.14-8.64 c-3.02-2.49-7.02-3.74-12-3.74c-4.65,0-8.45,1.21-11.39,3.61c-2.94,2.41-4.41,5.78-4.41,10.11c0,3.1,0.88,5.63,2.63,7.59 c1.75,1.96,3.92,3.45,6.49,4.47c2.57,1.02,6.19,2.19,10.84,3.49c5.63,1.55,10.17,3.08,13.6,4.59c3.43,1.51,6.37,3.84,8.82,6.98 c2.45,3.14,3.67,7.41,3.67,12.8c0,4.16-1.1,8.08-3.31,11.76c-2.21,3.67-5.47,6.66-9.8,8.94c-4.33,2.29-9.43,3.43-15.31,3.43 C1402.14,795.1,1397.1,794.1,1392.65,792.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1547.66,708.87v85.38h-11.15v-85.38H1547.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1715.22,733.61c-2.37-4.98-5.8-8.84-10.29-11.58c-4.49-2.74-9.72-4.1-15.68-4.1 c-5.96,0-11.33,1.37-16.11,4.1c-4.78,2.74-8.53,6.66-11.27,11.76c-2.74,5.1-4.1,11-4.1,17.7c0,6.7,1.37,12.58,4.1,17.64 c2.74,5.06,6.49,8.96,11.27,11.7c4.78,2.74,10.15,4.1,16.11,4.1c8.33,0,15.19-2.49,20.58-7.47c5.39-4.98,8.53-11.72,9.43-20.21 h-34.05v-9.06h45.93v8.57c-0.65,7.02-2.86,13.45-6.61,19.29c-3.76,5.84-8.7,10.45-14.82,13.84c-6.12,3.39-12.94,5.08-20.46,5.08 c-7.92,0-15.15-1.86-21.68-5.57c-6.53-3.71-11.7-8.88-15.5-15.5s-5.7-14.09-5.7-22.42c0-8.33,1.9-15.82,5.7-22.48 c3.8-6.65,8.96-11.84,15.5-15.56c6.53-3.71,13.76-5.57,21.68-5.57c9.06,0,17.09,2.25,24.07,6.74 c6.98,4.49,12.07,10.82,15.25,18.99H1715.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1895.52,708.87v85.38h-11.15v-38.71h-43.48v38.71h-11.15v-85.38h11.15v37.48h43.48v-37.48H1895.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2050.96,708.87v9.06h-23.27v76.31h-11.15v-76.31h-23.39v-9.06H2050.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2160.53,792.1c-4.45-2-7.94-4.78-10.47-8.33c-2.53-3.55-3.84-7.66-3.92-12.31h11.88 c0.41,4,2.06,7.37,4.96,10.11c2.9,2.74,7.12,4.1,12.68,4.1c5.31,0,9.49-1.33,12.55-3.98c3.06-2.65,4.59-6.06,4.59-10.23 c0-3.26-0.9-5.92-2.7-7.96c-1.8-2.04-4.04-3.59-6.74-4.65c-2.7-1.06-6.33-2.21-10.9-3.43c-5.63-1.47-10.15-2.94-13.54-4.41 c-3.39-1.47-6.29-3.78-8.7-6.92c-2.41-3.14-3.61-7.37-3.61-12.68c0-4.65,1.18-8.78,3.55-12.37c2.37-3.59,5.7-6.37,9.98-8.33 c4.29-1.96,9.21-2.94,14.76-2.94c8,0,14.56,2,19.66,6c5.1,4,7.98,9.31,8.63,15.92h-12.25c-0.41-3.26-2.12-6.14-5.14-8.64 c-3.02-2.49-7.02-3.74-12-3.74c-4.65,0-8.45,1.21-11.39,3.61c-2.94,2.41-4.41,5.78-4.41,10.11c0,3.1,0.88,5.63,2.63,7.59 c1.75,1.96,3.92,3.45,6.49,4.47c2.57,1.02,6.19,2.19,10.84,3.49c5.63,1.55,10.17,3.08,13.6,4.59c3.43,1.51,6.37,3.84,8.82,6.98 c2.45,3.14,3.67,7.41,3.67,12.8c0,4.16-1.1,8.08-3.31,11.76c-2.21,3.67-5.47,6.66-9.8,8.94c-4.33,2.29-9.43,3.43-15.31,3.43 C2170.02,795.1,2164.98,794.1,2160.53,792.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2071.18,623.67c-40.55,0-77.79-9.52-111.72-28.55c-33.93-19.04-60.83-45.31-80.69-78.83 c-19.86-33.93-29.79-72.2-29.79-114.82c0-42.21,9.93-80.07,29.79-113.58c19.86-33.93,46.76-60.41,80.69-79.45 c33.93-19.03,71.17-28.55,111.72-28.55c40.97,0,78.21,9.52,111.72,28.55c33.93,19.03,60.62,45.52,80.06,79.45 c19.86,33.52,29.79,71.38,29.79,113.58c0,42.62-9.93,80.89-29.79,114.82c-19.45,33.52-46.14,59.79-80.06,78.83 C2148.97,614.15,2111.73,623.67,2071.18,623.67z M2071.18,546.08c26.07,0,49.03-5.79,68.9-17.38 c19.86-12,35.38-28.96,46.55-50.89c11.17-21.93,16.76-47.38,16.76-76.34s-5.59-54.21-16.76-75.72 c-11.17-21.93-26.69-38.69-46.55-50.27c-19.86-11.59-42.83-17.38-68.9-17.38c-26.07,0-49.24,5.79-69.51,17.38 c-19.86,11.59-35.38,28.34-46.55,50.27c-11.17,21.52-16.76,46.76-16.76,75.72s5.58,54.41,16.76,76.34 c11.17,21.93,26.69,38.9,46.55,50.89C2021.94,540.29,2045.11,546.08,2071.18,546.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1758.49,619.32l-157.65-193.03v193.03h-86.89V186.09h86.89v194.27l157.65-194.27h104.89l-178.75,214.75 l183.72,218.48H1758.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1227.71,623.67c-40.55,0-77.79-9.52-111.72-28.55c-33.93-19.04-60.83-45.31-80.69-78.83 c-19.86-33.93-29.79-72.2-29.79-114.82c0-42.21,9.93-80.07,29.79-113.58c19.86-33.93,46.76-60.41,80.69-79.45 c33.93-19.03,71.17-28.55,111.72-28.55c40.96,0,78.2,9.52,111.72,28.55c33.93,19.03,60.62,45.52,80.07,79.45 c19.86,33.52,29.79,71.38,29.79,113.58c0,42.62-9.93,80.89-29.79,114.82c-19.45,33.52-46.13,59.79-80.07,78.83 C1305.51,614.15,1268.27,623.67,1227.71,623.67z M1227.71,546.08c26.07,0,49.03-5.79,68.89-17.38 c19.86-12,35.38-28.96,46.55-50.89c11.17-21.93,16.76-47.38,16.76-76.34s-5.59-54.21-16.76-75.72 c-11.17-21.93-26.69-38.69-46.55-50.27c-19.86-11.59-42.83-17.38-68.89-17.38s-49.24,5.79-69.52,17.38 c-19.86,11.59-35.38,28.34-46.55,50.27c-11.17,21.52-16.76,46.76-16.76,75.72s5.59,54.41,16.76,76.34s26.69,38.9,46.55,50.89 C1178.48,540.29,1201.65,546.08,1227.71,546.08z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDesk);
export default __webpack_public_path__ + "static/media/logo-desk.e71fe22a4e2483116dc429107988b3e4.svg";
export { ForwardRef as ReactComponent };